export enum TypeCronicsScheduleEnum {
  PROFISSIONAL = 1,
  DATA_HORARIO = 2,
  CONFIRMACAO = 3
}